<div
  class="app-layout-wrapper"
  [class.app-layout-wrapper--print]="hideAppChrome">
  <header *ngIf="!hideAppChrome" class="header">
    <app-header></app-header>
  </header>
  <nav *ngIf="!hideAppChrome" class="sidebar">
    <app-sidebar></app-sidebar>
  </nav>
  <section cdkScrollable class="main">
    <div class="breadcrumb-banner-row" *ngIf="!hideAppChrome">
      <div class="breadcrumb-banner-row__breadcrumb">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="breadcrumb-banner-row__end" aria-hidden="true"></div>
    </div>
    <router-outlet></router-outlet>
    <footer *ngIf="!hideAppChrome" class="footer">
      <app-footer></app-footer>
    </footer>
  </section>
</div>
